import axios from 'axios'
import { MessageBox, Message, Loading } from 'element-ui'
import qs from 'qs'

const baseUrl = process.env.NODE_ENV === "development" ? "dev-api" : process.env.VUE_APP_BASE_URL
const token = localStorage.getItem('token');
const cookie = localStorage.getItem('cookie')

const uniRequest = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  timeout: 60000
})

uniRequest.interceptors.request.use(
  (config) => {
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-Requested-With': 'XMLHttpRequest',
      // 'Content-Type': 'application/x-www-form-urlencoded'
      'X-Device-Id': localStorage.getItem('deviceId') || ''
    }
    if (config.params) {
      if (config.method === 'get') {
        config.params = JSON.parse(JSON.stringify(config.params))
        config.data = ''
      } else {
        const data = JSON.parse(JSON.stringify(config.params))
        config.data = qs.stringify(data)
        config.params = ''
      }
    }
    if (cookie) {
      headers.Cookie = cookie
    }
    if (token) {
      headers.token = token
    }
    config.headers = headers
    return config
  }
)

uniRequest.interceptors.response.use(
  (response) => {
    const res = response.data;

    if (res.code !== 600 && res.code !== '600') {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      if (
        res.code === '606' ||
        res.code === 606 ||
        res.code === '608' ||
        res.code === 608 ||
        res.code === '617' ||
        res.code === 617 ||
        res.code === '405' ||
        res.code === 405
      ) {
        MessageBox.confirm(res.msg, '提示', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          localStorage.clear();
          $('.login-eject').fadeIn();
        })
      }
      return {}
    } else {
      return res
    }
  },
  // (error) => {
  //   Message({
  //     message: error.message,
  //     type: 'error',
  //     duration: 5 * 1000
  //   })
  //   return Promise.reject(error)
  // }
)

export default uniRequest



// WEBPACK FOOTER //
// ./src/common/request.js